<div class="content" *ngIf="text1" [ngClass]="border ? 'border' : ''">
  <i *ngIf="icon" [ngClass]="icon"></i>
  <div *ngIf="contactPositionIndex===2">
    <div class="text" *ngIf="text1" [ngClass]="actionTextIndex===1 ? 'action' : ''" (click)="actionTextIndex===1 && onAction.emit()">{{text1 | cpLoginTranslate: text1Args | async}}</div>
    <div class="text">{{space}}</div>
    <a class="contact" *ngIf="contactInfo" href="tel:{{contactInfo}}">{{contactInfo}}</a>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text2" [ngClass]="actionTextIndex===2 ? 'action' : ''" (click)="actionTextIndex===2 && onAction.emit()">{{text2 | cpLoginTranslate | async}}</div>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text3" [ngClass]="actionTextIndex===3 ? 'action' : ''" (click)="actionTextIndex===3 && onAction.emit()">{{text3 | cpLoginTranslate | async}}</div>
  </div>
  <div *ngIf="contactPositionIndex===3">
    <div class="text" *ngIf="text1" [ngClass]="actionTextIndex===1 ? 'action' : ''" (click)="actionTextIndex===1 && onAction.emit()">{{text1 | cpLoginTranslate: text1Args | async}}</div>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text2" [ngClass]="actionTextIndex===2 ? 'action' : ''" (click)="actionTextIndex===2 && onAction.emit()">{{text2 | cpLoginTranslate | async}}</div>
    <div class="text">{{space}}</div>
    <a class="contact" *ngIf="contactInfo" href="tel:{{contactInfo}}">{{contactInfo}}</a>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text3" [ngClass]="actionTextIndex===3 ? 'action' : ''" (click)="actionTextIndex===3 && onAction.emit()">{{text3 | cpLoginTranslate | async}}</div>
  </div>
  <div *ngIf="!contactPositionIndex">
    <div class="text" *ngIf="text1" [ngClass]="actionTextIndex===1 ? 'action' : ''" (click)="actionTextIndex===1 && onAction.emit()">{{text1 | cpLoginTranslate: text1Args | async}}</div>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text2" [ngClass]="actionTextIndex===2 ? 'action' : ''" (click)="actionTextIndex===2 && onAction.emit()">{{text2 | cpLoginTranslate | async}}</div>
    <div class="text">{{space}}</div>
    <div class="text" *ngIf="text3" [ngClass]="actionTextIndex===3 ? 'action' : ''" (click)="actionTextIndex===3 && onAction.emit()">{{text3 | cpLoginTranslate | async}}</div>
    <div class="text">{{space}}</div>
    <a class="contact" *ngIf="contactInfo" href="tel:{{contactInfo}}">{{contactInfo}}</a>
  </div>
</div>
